import {
  ChangeEvent,
  DetailedHTMLProps,
  InputHTMLAttributes,
  ReactNode,
} from 'react'

import { cn } from '@bem-react/classname'
import parse from 'html-react-parser'

import { Message } from '@/components/UI/Message'

import './Checkbox.scss'
import { CheckboxTypes, CheckboxViews } from './types'

const cnCheckbox = cn('Checkbox')

export interface ICheckbox
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  type?: CheckboxTypes
  view?: CheckboxViews
  id: string
  label?: string
  name: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  checked?: boolean
  errors?: string
  children?: ReactNode
}

export const Checkbox = ({
  className,
  id,
  type = CheckboxTypes.Checkbox,
  label,
  view = CheckboxViews.Square,
  name,
  onChange,
  checked = false,
  children,
  errors,
}: ICheckbox): JSX.Element => {
  return (
    <div className={cnCheckbox(null, [className])}>
      <input
        type={type}
        className={cnCheckbox('input')}
        name={name}
        id={`${type}-` + id}
        onChange={onChange}
        {...(checked !== undefined && { checked })}
      />
      <label htmlFor={`${type}-` + id} className={cnCheckbox('label')}>
        <span
          className={cnCheckbox('wrap', {
            circle: view === CheckboxViews.Circle,
            square: view === CheckboxViews.Square,
            switch: view === CheckboxViews.Switch,
            default: view === CheckboxViews.Default,
          })}
        ></span>
        {(label || children) && (
          <span className={cnCheckbox('text')}>
            {label ? parse(label) : children ? children : ''}
          </span>
        )}
      </label>

      <Message
        className={cnCheckbox('error')}
        text={errors}
        type='error'
        open={!!errors}
      />
    </div>
  )
}
